import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import SignaturePad from "react-signature-canvas";
import { HeaderHomeSupervisor } from "./HeaderHomeSupervisor";
import { Footer } from "./Footer";
import { Alert, message } from "antd";
import { useParams } from "react-router-dom";
export const SupervisorPage = () => {
  const currentYear = new Date().getFullYear();
  const [spinners, setspinners] = useState(false);
  const [valueUserDetail, setValuegetuser] = useState([]);
  const [valueemployee, setvalueemployee] = useState([]);
  const [isClickedsuccess, setIsClickedSuccess] = useState(false);
  const [isClickedno, setIsClickedno] = useState(false);
  const [weekd, setweekd] = useState(false);
  const [isClickederror, setIsClickederror] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState("");
  const [weekdetails, setweekdetails] = useState([]);
  const [indx, setindx] = useState(null);
  const [signerror, setsignerror] = useState(false);
  const [supererror, setsupererror] = useState(false);
  const { code } = useParams();
  const [empnamevalue, setempname] = useState("");
  const [timesheet, setDataTimesheet] = useState([]);
  const [empstartdatevalue, empstartdate] = useState("");
  const [Datakms, setDatakms] = useState(0);
  const [Datahrs, setDatahrs] = useState(0);
  const clear = () => {
    this.sigPad.clear();
  };
  const isMobileScreen = window.innerWidth <= 767.98;
  const navigate = useNavigate();
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));
    document.title = "Signature Page";
  }, []);
  useEffect(() => {
    checkurl();
  }, [code]);
  const checkurl = () => {
    let formdata = {
      code: code,
    };
    axios
      .post(
        "https://jlmining.app/api/adminsupervisor/gettimesheetData",
        formdata,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        var alldata = res.data.result;

        if (alldata.length === 0) {
          navigate("/login");
        } else {
          var ress = alldata[0];

          var start = formatDate(ress.start_date);
          var end = formatDate(ress.end_date);
          setempname(ress);
          getuserweeklydata(
            start,
            end,
            ress.user_id,
            ress.roster_id,
            ress.client_id,
            ress.location_id
          );
        }
      })

      .catch((err) => { });
  };

  const getuserweeklydata = (
    start,
    end,
    user_id,
    roster_id,
    client_id,
    location_id
  ) => {
    let data = {
      start: start,
      end: end,
      user_id: user_id,
      roster_id: roster_id,
      client_id: client_id,
      location_id: location_id,
    };
    console.log(data);
    axios
      .post("https://jlmining.app/admin/getuserweeklydatas", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setDataTimesheet(res.data.data);
        if (res.data.data.length > 0) {
          if (res.data.data !== "") {
            empstartdate(res.data.data[0].nd);
            setIsClickedno(false);
            setIsClicked(true);
          }
        } else {
          setIsClickedno(true);
        }
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/admin/getuserweeklytraveldata", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setDatakms(res.data.row[0].kmss);
        setDatahrs(res.data.row[0].hrs);
      })
      .catch((err) => { });
    axios
      .post("https://jlmining.app/admin/getuserweeklytravelrecipt", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.result.length > 0) {
          var ft = [];
          var o_tt = [];
          for (let tt = 0; tt < res.data.result.length; tt++) {
            var t = res.data.result[tt].ticket_file;
            if (t != "" && t != null) {
              var ft = t;
            }
          }
          for (let ot = 0; ot < res.data.result.length; ot++) {
            var o = res.data.result[ot].other_file;
            if (o != "" && o != null) {
              var o_tt = o;
            }
          }
          if (o_tt != "" && o_tt != null) {
            const fileo = JSON.parse(o_tt);
          }
        }
      })
      .catch((err) => { });
  };
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  const clearCanvas = () => {
    canvasRef.current.clear();
  };
  const captureSignature = () => {
    const canvas = canvasRef.current;
    const signatureData = canvas.toDataURL(); // Convert canvas to image data URL
    setSignatureDataURL(signatureData);
  };
  const apiurl = "https://jlmining.app/uploads/";

  var imageUrl = `${apiurl}${valueUserDetail.image}`;
  if (valueUserDetail.image == null) {
    var im = "male-upload.png";
    var imageUrl = `${apiurl}${im}`;
  } else {
    var imageUrl = `${apiurl}${valueUserDetail.image}`;
  }
  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0"); // Add leading zero if needed
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const handleformsubmit = (event) => {
    const vl = event.target;

    const canvas = canvasRef.current;
    const signatureData = canvas.toDataURL(); // Convert canvas to image data URL

    if (canvasRef.current.isEmpty()) {
      setsignerror(true);
      return;
    } else {
      setsignerror(false);
    }
    if (vl.super_viser.value === "") {
      setsupererror(true);
      return;
    } else {
      setsupererror(false);
    }

    setSignatureDataURL(signatureData);

    if (vl.super_viser.value) {
      let formdata = {
        rows: timesheet,
        signature_img: signatureData,
        super_viser: vl.super_viser.value,
        code: code,
      };
      setspinners(true);
      axios
        .post(
          "https://jlmining.app/api/adminsupervisor/updatesign",
          formdata,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          setspinners(false);
          setIsClicked(false);
          if (res.data.status == "2") {
            message.error("Some thing went wrong, Please try again");
          } else {
            message.success("You are successfully submitted your Time Sheet");
          }
          setTimeout(() => {
            window.location.reload();
          }, 4500);
        })
        .catch((err) => { });
    }
  };

  return (
    <>
      <HeaderHomeSupervisor />
      <section className="innerbanner text-center py-5 d-block">
        <div className="container-lg">
          <h3 className="fs-30 fw-800 text-white">Supervisor Signature</h3>
        </div>
      </section>
      <section className="profile-box d-block">
        <div className="container-lg">
          <div className="row gy-4 align-items-center">
            <div className="col-lg-4 col-lg-3">
              <div className="d-flex flex-column gap-2 text-center pic-emp">
                <div className="emplo-box-pic ofit mx-auto"></div>
                <div className="d-flex flex-column">
                  <h3 className="fs-26 text-black fw-800"></h3>
                  <h4 className="fs-18 text-black"></h4>
                  {/* <p className="fs-12 text-black">{valueUserDetail.firstname}</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="d-block py-5">
        <div className="container-lg">
          <div className="row gy-4">
            <div className="col-lg-12">
              <div className="d-flex flex-column gap-2">
                <div className="d-flex flex-column gap-2 flex-md-row justify-content-between">
                  <div className="d-block red-heading p-2 w-100 w-md-50 maintimesheet">
                    <div className="d-flex flex-column gap-2  bg-white shadow p-5 timesheet-boxes">
                      <h5 className="text-black text-center">Time Sheet</h5>

                      <div className="table-responsive pb-4">
                        <div style={{ display: "block" }}>
                          <table className="table mb-1">
                            <thead>
                              <tr>
                                <tr>
                                  <td>
                                    <h6 className="">Employee Name:</h6>
                                  </td>
                                  <td>
                                    <p className="">
                                      {empnamevalue.step2_title}{" "}
                                      {empnamevalue.first_name}{" "}
                                      {empnamevalue.last_name}
                                    </p>
                                  </td>
                                </tr>
                              </tr>
                            </thead>
                          </table>
                        </div>
                        <div
                          className={`supervisor ${timesheet.length > 5 ? "table-responsive" : ""
                            }`}
                        >
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Day</th>
                                <th>Date</th>
                                <th>Hours</th>
                              </tr>
                            </thead>
                            <tbody className="">
                              {Array.isArray(timesheet) ? (
                                timesheet.map((item, index) => (
                                  <tr>
                                    <td>{item.dd}</td>
                                    <td>{item.nd}</td>

                                    <td>{item.hours}</td>
                                  </tr>
                                ))
                              ) : (
                                <Link> No data available </Link>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {weekd && (
                    <div className="d-block red-heading w-100 w-md-50 p-2 maintimesheet">
                      <table className="date-box">
                        <tr>
                          <th></th>
                          <th>Dates</th>
                          <th>Hours</th>
                        </tr>
                        {Array.isArray(weekdetails) ? (
                          weekdetails.map((item, index) => (
                            <tr>
                              <td colspan="1">{item.dd}</td>
                              <td>{item.nd}</td>
                              <td>{item.hours}</td>
                            </tr>
                          ))
                        ) : (
                          <Link> No data available </Link>
                        )}
                      </table>
                    </div>
                  )}
                </div>

                <div>
                  <form
                    action="javascript:void(0)"
                    onSubmit={handleformsubmit}
                    method="post"
                  >
                    <input
                      type="hidden"
                      name="client_id"
                      value={valueemployee.client_id}
                    />
                    <input
                      type="hidden"
                      name="attend_id"
                      value={valueemployee.id}
                    />
                    <input
                      type="hidden"
                      name="user_id"
                      value={valueemployee.user_id}
                    />
                    <input
                      type="hidden"
                      name="hours"
                      value={valueemployee.hours}
                    />

                    <div className="d-flex flex-column gap-3 mt-4">
                      <h4 className="text-black fs-16 fw-400">
                        Supervisor Signature:
                      </h4>
                      <div className="w-100  shadow signimg">
                        <SignaturePad
                          ref={canvasRef}
                          canvasProps={{
                            style: {
                              border: "1px solid black",
                              height: "200px",
                            },
                          }}
                        />
                      </div>
                      {signerror && (
                        <span className="text-danger">
                          This field is required
                        </span>
                      )}
                    </div>
                    <div className="d-flex flex-column gap-3 mt-4">
                      <h4 className="text-black fs-16 fw-400">
                        Superviser Name <span>*</span>
                      </h4>
                      <input
                        type=""
                        name="super_viser"
                        className="form-control"
                        placeholder="Enter superviser name..."
                      />
                      {supererror && (
                        <span className="text-danger">
                          This field is required
                        </span>
                      )}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                      <button
                        onClick={clearCanvas}
                        className="subbtn"
                        type="button"
                      >
                        Clear
                      </button>

                      <button
                        style={{
                          opacity: spinners ? 0.5 : 1,
                          pointerEvents: spinners ? "none" : "auto",
                        }}
                        type="submit"
                        onClick={captureSignature}
                        className="subbtn"
                      >
                        Submit
                      </button>
                      {spinners && (
                        <div class="spinner-border text-dark" role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              {isClickedsuccess && (
                <div className="d-block text-center p-4 shadow border border-secondary border-opacity-25 mt-4">
                  <h3 className="myytext-primary fs-20 fw-800">
                    You are successfully submitted your Time Sheet
                  </h3>
                </div>
              )}
              {isClickederror && (
                <div className="d-block text-center p-4 shadow border border-secondary border-opacity-25 mt-4">
                  <h3 className="myytext-primary fs-20 fw-800">
                    You are successfully submitted your Time Sheet
                  </h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
